import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../components/HomePage.vue';
import WorkPage from '../components/WorkPage.vue';
import ResearchPage from '../components/ResearchPage.vue';
import MentorshipPage from '../components/MentorshipPage.vue';
import ResumePage from '../components/ResumePage.vue';
import ContactPage from '../components/ContactPage.vue';
import BlogPage from '../components/BlogPage.vue';
import DggramPage from '../components/DggramPage.vue';
import ApartmentPage from '../components/ApartmentPage.vue';
import BottomSheetModal from '../components/BottomSheetModal.vue';
import HeaderPage from '../components/HeaderPage.vue';
import FloatingHeader from '../components/FloatingHeader.vue';
import FooterPage from '../components/FooterPage.vue';

const routes = [
  { 
    path: '/', 
    name: 'home',
    component: HomePage, 
    meta: { title: 'Home - Ravindra Bachate' }
  },
  { 
    path: '/workpage', 
    name: 'work',
    component: WorkPage, 
    meta: { title: 'Work - Ravindra Bachate' }
  },
  { 
    path: '/researchpage', 
    name: 'research',
    component: ResearchPage, 
    meta: { title: 'Research - Ravindra Bachate' } 
  },
  { 
    path: '/mentorshippage', 
    name: 'mentorship',
    component: MentorshipPage, 
    meta: { title: 'Mentorship - Ravindra Bachate' } 
  },
  { 
    path: '/resumepage', 
    name: 'resume',
    component: ResumePage, 
    meta: { title: 'Resume - Ravindra Bachate' }
  },
  { 
    path: '/contactpage', 
    name: 'contact',
    component: ContactPage, 
    meta: { title: 'Contact - Ravindra Bachate' } 
  },
  { 
    path: '/blogpage', 
    name: 'blog',
    component: BlogPage, 
    meta: { title: 'Blogs - Ravindra Bachate' } 
  },
  { 
    path: '/dggrampage', 
    name: 'dggram',
    component: DggramPage, 
    meta: { title: 'Blogs - Ravindra Bachate' } 
  },
  { 
    path: '/apartmentpage', 
    name: 'apartment',
    component: ApartmentPage, 
    meta: { title: 'Apartment Case Study - Ravindra Bachate' } 
  },
  { 
    path: '/headerpage', 
    name: 'header',
    component: HeaderPage 
  },
  { 
    path: '/bottomsheetmodal', 
    name: 'bottomsheet',
    component: BottomSheetModal
  },
  { 
    path: '/floatingheader', 
    name: 'floatingheader',
    component: FloatingHeader 
  },
  { 
    path: '/footerpage', 
    name: 'footer',
    component: FooterPage 
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  }
});

router.beforeEach((to, from, next) => {
  // Set the title
  document.title = to.meta.title || 'Default Title';
  
  // Force a scroll to top
  window.scrollTo(0, 0);
  
  // Continue with the navigation
  next();
});

export default router;
